var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-title"},[(_vm.tags.length)?_c('div',{staticClass:"c-title-tags"},_vm._l((_vm.tags),function(tag,index){return _c('span',{key:index,staticClass:"c-title-tag"},[_vm._v(_vm._s(tag))])}),0):_vm._e(),_c('h1',{staticClass:"c-title-h1 ellipsis",attrs:{"title":_vm.name}},[_vm._v(" "+_vm._s(_vm.name)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }